<template>
    <div class="login-wrap">
      <div class="setup-instructions">
        <div class="heading-tertiary">RSDM Weekly Coach Payment Portal.{{id}}</div>
        <p>Connected with Stripe Customer Portal Service!</p>
      </div>
      <div class="forget-wrap">
        <router-link to="/setup">Register</router-link> | 
        <router-link to="/forget">Forget Password?</router-link>
      </div>
      <form @submit.prevent="userLogin" autocomplete="off">
        <div class="email">
          <input type="email" v-model="email" placeholder="email" autocomplete="false">
        </div>
        <div class="password">
          <input type="password" v-model="password" placeholder="password" autocomplete="false">
        </div>
        <button type="submit">Login</button>
      </form>
      <div class="error" v-if="error">{{this.error}}</div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  metaInfo: {
    title: 'DIY Marketing Resources APP | Login'
  },
  data() {
    return {
      email: '',
      password: '',
      error: '',
      err: '',
      user: null,
      id: ''
    }
  },
  created() {
    this.email = this.$route.query.email;
  },
  mounted() {
  },
  methods: {
    userLogin() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
            this.$router.replace('/home').catch(err => {})
        })
        .catch((error) => {
          alert(error.message);
        });
    }
  }
}
</script>